// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__JS3R1","label":"Radio_label__37UF1","checkMark":"Radio_checkMark__1Z-ui","disabled":"Radio_disabled__1Vpn-"};